// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f3783f50","239":"f9ef2257","455":"338a8606"}[chunkId] + ".chunk.js";
};